import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "marketing-service-banner";

const GET_ALL_MARKETING_SERVICE_BANNER_URL = `${prefix}/all`;
const GET_MARKETING_SERVICE_BANNER_URL = `${prefix}/get`;
const CREATE_MARKETING_SERVICE_BANNER_URL = `${prefix}/create`;
const UPDATE_MARKETING_SERVICE_BANNER_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_MARKETING_SERVICE_BANNER_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllMarketingServiceBanner
 * @desc get all service banner data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} service banner array
 */
export const getAllMarketingServiceBanner = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_MARKETING_SERVICE_BANNER_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllMarketingServiceBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllMarketingServiceBanner */

/**
 * @func getMarketingServiceBanner
 * @desc get service banner data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} service banner array
 */
export const getMarketingServiceBanner = async (signal) => {
    try {
        const { data, status } = await axios.get(GET_MARKETING_SERVICE_BANNER_URL, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getMarketingServiceBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getMarketingServiceBanner */

/**
 * @func createMarketingServiceBanner
 * @desc create new service banner
 * @author izeberg
 * @param {Object} body - create service banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} create status
 */
export const createMarketingServiceBanner = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_MARKETING_SERVICE_BANNER_URL, body, {
            signal,
        });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createMarketingServiceBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createMarketingServiceBanner */

/**
 * @func updateMarketingServiceBannerById
 * @desc update service banner by id
 * @author izeberg
 * @param {number} id - service banner id
 * @param {Object} body - update service banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateMarketingServiceBannerById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_MARKETING_SERVICE_BANNER_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateMarketingServiceBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateMarketingServiceBannerById */

/**
 * @func deleteMarketingServiceBannerById
 * @desc delete service banner by id
 * @author izeberg
 * @param {Object} body - create service banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} service banner array
 */
export const deleteMarketingServiceBannerById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_MARKETING_SERVICE_BANNER_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteMarketingServiceBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteMarketingServiceBannerById */
